var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"category-container"},[_c('h1',{staticClass:"category-header mb-5",domProps:{"innerHTML":_vm._s(_vm.categoryTitle)}}),_c('div',{staticClass:"d-flex flex-wrap justify-content-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }